import { Grid, Typography } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  addApartmentMedia,
  deleteApartmentMedia,
  reorderApartmentMedia,
  confirmMedia
} from '../../../../actions/apartments'
import { AddApartmentMedia } from '../../../../actions/types'
import { MediaSlider } from '../../../../components/Display'
import { selectIsMobile } from '../../../../selectors/users'
import { BucketObject } from '../../../../services/storage/types'
import { MuiClasses } from '../../../../types'
import { Apartment } from '../../../../types/apartments'
import { StateInterface } from '../../../../types/states'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import Dialog from '../../../Dialog'
import ApartmentMediaForm from '../../Forms/ApartmentMediaForm'

interface AddressAndMediaProps {
  files: BucketObject[]
  classes: MuiClasses
  apartment: Apartment
  deleteMedia: (arg: any) => any
  reorderMedia: (arg: any) => any
  addApartmentMediaFiles: AddApartmentMedia
  doConfirmMedia: () => void
  t: i18n.TFunction
  isMobile: any
}

const AddressAndMedia: FC<AddressAndMediaProps> = ({
  files,
  t,
  classes,
  apartment,
  deleteMedia,
  reorderMedia,
  addApartmentMediaFiles,
  doConfirmMedia,
  isMobile
}) => {
  const address = apartment?.information?.address || ''
  const postalCode = apartment?.information?.postalCode || ''
  const city = apartment?.information?.postalArea || ''
  const addressCombined = `${address}, ${postalCode} ${city}`
  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      justify='space-between'
      className={classes.addressAndMedia}
    >
      <Grid
        item
        xs={12}
        container
        direction='row'
        justify='space-between'
        alignItems='center'
      >
        <Grid
          container
          item
          xs={12}
          justify='space-between'
          alignItems='center'
          className={classes.addressAndMediaTitle}
        >
          <Grid item xs={12} sm={7}>
            <Typography variant='h5' className={classes.leftTitle}>
              {addressCombined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            style={{ margin: '0 auto', marginTop: '0.5rem' }}
          >
            <Dialog
              fullScreenDialogMobile={true}
              dialogId='addMediaDialog'
              buttonClassName={classes.primaryBtn}
              buttonLabel={t('apartment.mediaUpload.addImages')}
              title={t('apartment.mediaUpload.addImages')}
              maxWidth='lg'
              color='primary'
              buttonFullWidth
              Content={
                <ApartmentMediaForm
                  deleteMedia={deleteMedia}
                  reorderMedia={reorderMedia}
                  addApartmentMedia={addApartmentMediaFiles}
                  files={files}
                  media={apartment.media}
                  confirmMedia={doConfirmMedia}
                  classes={classes}
                  isMobile={isMobile}
                />
              }
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item container justify='center'>
        <Grid item xs={12} sm={12}>
          <MediaSlider
            t={t}
            files={files}
            media={apartment.media}
            imageHeight='60vh'
            imageBackground='#E7ECEF'
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
const mapStateToProps = (state: StateInterface) => ({
  isMobile: selectIsMobile(state)
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  addApartmentMediaFiles: bindSubmitActionToPromise(
    dispatch,
    addApartmentMedia
  ),
  deleteMedia: (fileKey: string) => dispatch(deleteApartmentMedia(fileKey)),
  reorderMedia: ({
    oldIndex,
    newIndex
  }: {
    oldIndex: number
    newIndex: number
  }) => dispatch(reorderApartmentMedia({ oldIndex, newIndex })),
  doConfirmMedia: () => dispatch(confirmMedia())
})

export default connect(mapStateToProps, mapDispatchToProps)(AddressAndMedia)
